import { faTrash, faTrashUndo } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "antd"

type Props = {
  isDeleted: boolean
  onClick: () => void
}

const { Link } = Typography

const ItemDeleteLink = ({isDeleted, onClick}: Props) => {
  if (isDeleted) {
    return <Link onClick={onClick}>
      <FontAwesomeIcon icon={faTrashUndo} />
    </Link>
  }

  return <Link onClick={onClick} type="danger">
    <FontAwesomeIcon icon={faTrash} />
  </Link>
}

export default ItemDeleteLink